import styled from "styled-components";

export const Btn = styled.button`
  width: 100%;
  background-color: var(--primary-color);
  height: 50px;
  border-radius: 50px;
  color: var(--white-color);
`;
